import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    static get targets() {
        return ['content', 'expand', 'collapse'];
    }

    connect() {

        const content = this.targets.find('content');
        const expand = this.targets.find('expand');
        const collapse = this.targets.find('collapse');
        const maxHeight = content.dataset.height;

        let totalChildrenHeight = 0;
        for (const child of content.children) {
            totalChildrenHeight += child.clientHeight;
        }

        content.style.height = `${totalChildrenHeight}px`;
        content.style.maxHeight = `${maxHeight}px`;
        content.style.overflow = `hidden`;

        if (totalChildrenHeight > maxHeight) {
            expand.classList.remove('d-none');
        }

        expand.addEventListener('click', () => {
            expand.classList.add('d-none');
            collapse.classList.remove('d-none');
            content.style.maxHeight = '';
            content.style.height = '';
        });

        collapse.addEventListener('click', () => {
            expand.classList.remove('d-none');
            collapse.classList.add('d-none');
            content.style.maxHeight = `${maxHeight}px`;
            content.style.height = `${totalChildrenHeight}px`;
        });
    }
}
